module.exports = __webpack_public_path__ + "media/frances.aaf2458d.mp4";